import { Component, OnInit, OnDestroy, Renderer2 } from '@angular/core';
import { sessionStorage } from '../localstorage.service';
import { Router } from '@angular/router';
import { DialogComponent } from '../dialog.component';
import { DatabaseService } from 'src/_services/DatabaseService';
import { BottomSheetComponent } from '../bottom-sheet/bottom-sheet.component';
import { ToastrManager } from 'ng6-toastr-notifications';
import { Subject, Subscription } from 'rxjs';
import { debounceTime, distinctUntilChanged, switchMap, filter } from 'rxjs/operators';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']

})
export class HeaderComponent implements OnInit, OnDestroy {
  searchData: any = {};
  login_data: any = {};
  dataList: any = [];
  private searchSubject = new Subject<string>();
  private searchSub: Subscription;
  constructor(private renderer: Renderer2, public session: sessionStorage, public toastCtrl: ToastrManager, public serve: DatabaseService, public router: Router, public dialog: DialogComponent) {
    this.login_data = this.session.getSession();
    this.login_data = this.login_data.value;
    this.login_data = this.login_data.data;
  }

  ngOnInit() {
    this.searchSub = this.searchSubject.pipe(
      debounceTime(400),
      distinctUntilChanged(),
      filter(search => search.length > 3),
      switchMap(search => this.serve.post_rqst({ 'search': search }, "Master/masterSearch"))
    ).subscribe(result => {
      if (result['statusCode'] == 200) {
        this.dataList = result['result'];
      } else {
        this.toastCtrl.errorToastr(result['statusMsg']);
      }
    });
  }

  ngOnDestroy() {
    if (this.searchSub) {
      this.searchSub.unsubscribe();
    }
  }

  colorMode: boolean = false;
  nightMode() {
    this.colorMode = !this.colorMode;
    if (this.colorMode) {
      this.renderer.addClass(document.body, 'dark-mode');
    }
    else {
      this.renderer.removeClass(document.body, 'dark-mode');
    }
  }

  get isNavActive(): boolean {
    return document.body.classList.contains('nav-active');
  }

  // Mobile par sidebar drawer hota hai (`drawer-open`), desktop par
  // collapsible rail (`nav-active`) — dono ka toggle alag hai.
  get isMobile(): boolean {
    return window.innerWidth <= 820;
  }

  get isDrawerOpen(): boolean {
    return document.body.classList.contains('drawer-open');
  }

  toggleNav() {
    if (this.isMobile) {
      if (this.isDrawerOpen) {
        this.renderer.removeClass(document.body, 'drawer-open');
      } else {
        this.renderer.addClass(document.body, 'drawer-open');
      }
      return;
    }
    if (this.isNavActive) {
      this.renderer.removeClass(document.body, 'nav-active');
    } else {
      this.renderer.addClass(document.body, 'nav-active');
    }
  }

  filter_dr(search) {
    if (search.length <= 3) {
      this.dataList = [];
      return;
    }
    this.searchSubject.next(search);
  }


  id: any
  type: any
  dr_type: any
  gotodetail(data) {
    this.id = data.id
    this.type = data.module_name;
    this.dr_type = data.type
    if (this.type == 'Channel Partner' || this.type == 'Ply Expert' || this.type == 'Sub Dealer'|| this.type == 'Primary OEM' || this.type == 'Secondary OEM' || this.type == 'Builder' || this.type == 'Ambassador') {
      this.router.navigate(['/distribution-list/' + data.type + '/' + data.module_name + '/distribution-detail/' + this.id + '/' + 'Profile'], { queryParams: { 'state': data.state, 'id': data.id, 'type': data.type } })
    }
    else if (this.type == 'Lead') {
      console.log("inside lead")
      this.router.navigate(['/lead-list/lead-detail/'+ this.id])
    }
    else if (this.type == 'Customer' || this.type == 'Plumber') {
      this.router.navigate(['/influencer/' + data.type + '/' + data.module_name + '/influencer-detail/' + this.id + '/' + data.type])
    }
    else if (this.type == '') {
      this.router.navigate(['/sale-user-list/sale-user-detail/' + data.id])
    }
    // else {
    //   this.router.navigate(['/sale-user-list/sale-user-detail/'+data.id]);
    // }
    this.searchData = {}
    this.dataList = [];
  }





  logout() {
    this.dialog.confirm("Logout").then((result) => {
      if (result) {
        this.session.LogOutSession();
        this.serve.datauser = {};
        this.router.navigate(['']);
      }
    });

  }
}
